import React from 'react';
import globalStyles from '../../lib/styles/Global_styles';
import styled, { StylesProps, useStyles } from '../../lib/styles';

export interface BlockTitleProps {
  title: string;
  title_anchor?: string;
  subtitle: string;
  brand: string;
}

const BlockTitle = ({
  title,
  title_anchor,
  subtitle,
  styles,
}: BlockTitleProps & StylesProps<typeof globalStyles>) => {
  return (
    <div 
      id={title_anchor ?? undefined}
      className={styles.blockHeader}
    >
      {title && <h2 className={styles.blockTitle}>{title}</h2>}

      {subtitle && (
        <h3
          className={styles.blockSubtitle}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </div>
  );
};

export default styled(globalStyles)(BlockTitle);
